import APIConstant from 'constants/ApiConstant';
import { MYM_WEB } from 'constants/RequestUrlConstant';
import { makeAutoObservable, runInAction } from 'mobx';
import { getRequest } from 'utils/apiUtils';
import { getValidDataFromResponse, isValidArray, sortData } from 'utils/utilities';

class EquipmentStore {
	equipmentDetails = [];
	allEquipmentDetails = []; // Store unfiltered data
	filters = {
		facility: null,
		serialNumber: null,
		testTagDate: null,
	};

	constructor({ reportsStore }) {
		makeAutoObservable(this);
		this.reportsStore = reportsStore;
	}

	getAllEquipmentDetails = async () => {
		try {
			this.updateGlobalLoadingState();

			const { response } = await getRequest({ url: APIConstant.ALL_EQUIPMENT_DETAILS, rbu: MYM_WEB });

			const { result, error } = getValidDataFromResponse({ response });

			if (!error && isValidArray(result)) {
				runInAction(() => {
					this.allEquipmentDetails = sortData(result, 'facility_name');
					this.applyFilters();
				});
			}

			runInAction(() => {
				this.updateGlobalLoadingState();
			});
		} catch (error) {
			this.updateGlobalLoadingState();
		}
	};

	handleFilterChange = (filterType, value) => {
		runInAction(() => {
			this.filters[filterType] = value;
			this.applyFilters();
		});
	};

	applyFilters = () => {
		runInAction(() => {
			let filteredData = [...this.allEquipmentDetails];

			// Filter by facility
			if (this.filters.facility) {
				filteredData = filteredData.filter(item =>
					item.facility_name?.toLowerCase().includes(this.filters.facility.toLowerCase())
				);
			}

			// Filter by serial number
			if (this.filters.serialNumber) {
				filteredData = filteredData.filter(item =>
					item.serial_no?.toLowerCase().includes(this.filters.serialNumber.toLowerCase())
				);
			}

			// Filter by test & tag date
			if (this.filters.testTagDate) {
				filteredData = filteredData.filter(item =>
					item.test_tag_date === this.filters.testTagDate
				);
			}

			this.equipmentDetails = filteredData;
		});
	};

	getFacilityList = () => {
		// Get unique facility names for dropdown
		const facilities = [...new Set(this.allEquipmentDetails.map(item => item.facility_name))];
		return facilities.filter(Boolean).sort();
	};

	getSerialNumberList = () => {
		// Get unique serial numbers for dropdown
		const serialNumbers = [...new Set(this.allEquipmentDetails.map(item => item.serial_no))];
		return serialNumbers.filter(Boolean).sort();
	};

	getTestTagDateList = () => {
		// Get unique test & tag dates for dropdown
		const dates = [...new Set(this.allEquipmentDetails.map(item => item.test_tag_date))];
		return dates.filter(Boolean).sort();
	};

	updateGlobalLoadingState = () => {
		this.reportsStore.updateReportsLoadingState();
	};
}

export default EquipmentStore;
